module.exports = g_tutorial;